import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content", "refKey"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useEffect, useRef } from 'react';
import Text from 'components/Text';
import EasyTooltip from 'components/EasyTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function OverflowTooltip(_ref) {
  var children = _ref.children,
    content = _ref.content,
    _ref$refKey = _ref.refKey,
    refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasOverflow = _useState2[0],
    setHasOverflow = _useState2[1];
  var overflowRef = useRef(null);
  useEffect(function () {
    if (overflowRef.current) {
      var _overflowRef$current = overflowRef.current,
        scrollWidth = _overflowRef$current.scrollWidth,
        offsetWidth = _overflowRef$current.offsetWidth;
      var isOverflowing = scrollWidth > offsetWidth;
      setHasOverflow(isOverflowing);
    }
  }, [children]);
  var tooltipContent = hasOverflow ? content : undefined;

  // Text-only children that don't have a wrapper element
  // get default "ellipsis" overflow styles
  if (typeof children === 'string') {
    return /*#__PURE__*/_jsx(EasyTooltip, _objectSpread(_objectSpread({
      content: tooltipContent,
      placement: "top-start"
    }, otherProps), {}, {
      children: /*#__PURE__*/_jsx(Text, {
        ref: overflowRef,
        overflow: "ellipsis",
        display: "block",
        children: children
      })
    }));
  }
  return /*#__PURE__*/_jsx(EasyTooltip, _objectSpread(_objectSpread({
    content: tooltipContent,
    placement: "top-start"
  }, otherProps), {}, {
    children: /*#__PURE__*/React.isValidElement(children) && /*#__PURE__*/React.cloneElement(React.Children.only(children), _defineProperty({}, refKey, overflowRef))
  }));
}
export default OverflowTooltip;